import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=3fe28970&scoped=true"
import script from "./CompanyEdit.vue?vue&type=script&lang=js"
export * from "./CompanyEdit.vue?vue&type=script&lang=js"
import style0 from "./CompanyEdit.vue?vue&type=style&index=0&id=3fe28970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe28970",
  null
  
)

export default component.exports